import * as React from 'react';

function SvgDribble(props) {
    return (
        <svg width={34} height={34} viewBox="0 0 34 34" {...props}>
            <path
                d="M16.854.814C7.844.814.542 8.152.542 17.203c0 9.05 7.302 16.388 16.312 16.388 9.01 0 16.313-7.338 16.313-16.388 0-9.051-7.303-16.389-16.313-16.389zm13.438 15.625c-3.5-.576-6.72-.608-9.656-.1a57.7 57.7 0 00-1.043-2.294c3.14-1.366 5.662-3.22 7.542-5.575a13.505 13.505 0 013.157 7.97zm-5.223-9.945c-1.638 2.122-3.899 3.8-6.778 5.026a63.253 63.253 0 00-4.741-7.427 13.39 13.39 0 013.304-.429c3.093 0 5.938 1.064 8.215 2.83zM10.774 5.138a60.926 60.926 0 014.808 7.349c-3.303.976-7.247 1.477-11.805 1.509a13.552 13.552 0 016.997-8.858zM3.379 17.203l.018-.35c5.232-.007 9.745-.612 13.525-1.805.317.648.62 1.3.911 1.955-4.595 1.444-8.38 4.4-11.333 8.85a13.511 13.511 0 01-3.121-8.65zm5.205 10.666c2.677-4.217 6.093-6.963 10.328-8.231a53.647 53.647 0 012.778 10.188c-4.553 1.763-9.452.91-13.106-1.957zm15.75.587a56.333 56.333 0 00-2.61-9.42c2.55-.361 5.355-.267 8.426.268a13.558 13.558 0 01-5.816 9.152z"
                fillRule="nonzero"
            />
        </svg>
    );
}

export default SvgDribble;
